import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { ControllerService } from '../shared/services/controller.service';
import { StoreHelper } from '../shared/helpers/store.helper';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, public controller: ControllerService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


      if (this.authService.isAuthenticated() && StoreHelper.isActive()) {

        // ensure loaded.

        if( !this.controller.getLoaded() ){
            console.log('Content not loaded, redirecting to start')
            this.router.navigate(['/start'])
            return false
        }

        return true
      }

      this.router.navigate(['/signin']);

      return false
  }
}
